module.exports = __webpack_public_path__ + "assets/images/template-2.4d97e3a182d4800a74938992505e13e0.png";